import Image from "next/image";
import React from "react";
import useTranslation from "next-translate/useTranslation";

import banner from "@public/images/banner-slide.png";

const Banner = () => {
  const { t } = useTranslation("about-us");
  return (
    <div className="banner-about-us">
      <div className="banner-about-us__background" />
      <div className="banner-about-us__content">
        <div className="banner-about-us__content__right">
          <Image src={banner} alt="banner" />
        </div>
        <div className="banner-about-us__content__left">
          <h2>{t("story.title")}</h2>
          <div />
          <p>{t("story.desc")}</p>
          <p className="text-yellow">{t("story.supDesc")}</p>
        </div>
      </div>
    </div>
  );
};

export default Banner;
